<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Career Opportunities at Xipe Tech</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>{{ data?.title }}</li>
            </ul>
        </div>
    </div>
</div>

<section class="space">
    <div class="container">
        <div class="row mb-5">
            <div class="col-12">
                <div *ngIf="successMessage" class="alert alert-success" role="alert">
                    {{ successMessage }}
                </div>

                <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
                    {{ errorMessage }}
                </div>
            </div>
        </div>
        <div class="job-post style2 mb-60 smoke-bg" *ngIf="data">
            <div class="job-content_wrapper">
                <div class="job-content d-sm-flex align-items-start justify-content-between text-center text-sm-start">
                    <div class="job-post_author">
                        <span class="date"><span class="deadline">Deadline: </span> {{ data?.clossing_date }}</span>
                        <div class="job-post_author-content d-sm-flex align-items-center">
                            <div class="job-author">
                                <img [src]="data.cover_image" (error)="onImageError($event)" alt="{{ data.title }}" />
                            </div>
                            <div class="author-info">
                                <span class="company-name">XipeTech</span>
                                <span class="job-title">{{ data?.title }}</span>
                                <span class="location me-1">
                                    <i class="fa-light fa-location-dot"></i> XipeTech
                                </span>
                                <span class="location experience"
                                    *ngIf="data.min_experience && data.min_experience.trim() !== ''">
                                    <i class="fa-light fa-clock"></i>
                                    {{ data?.min_experience ?? '' }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="job-post_date text-center text-sm-end">
                        <div class="job-post-action d-sm-flex align-items-center mb-20">
                            <span class="icon">
                                <i class="fa-solid fa-heart"></i>
                            </span>
                            <a (click)="scrollToForm()" class="th-btn style2 cursor-pointer th-radius ms-sm-4">
                                Apply Now
                            </a>
                        </div>
                        <span class="price d-block" *ngIf="data.expected_salary && data.expected_salary.trim() !== ''">
                            <i class="fa-sharp fa-regular fa-indian-rupee-sign me-2"></i>
                            {{ data?.expected_salary }}
                        </span>
                    </div>
                </div>
                <div class="job-category_wrapper d-sm-flex align-items-center justify-content-between">
                    <div class="job-category" *ngIf="data.tags && data.tags.length > 0">
                        <a class="m-1" href="javascript:void(0);" *ngFor="let tag of data.tags">
                            {{ tag | titlecase }}
                        </a>
                    </div>
                    <div class="star">
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-xxl-8 col-lg-8">
                <div [innerHTML]="data?.content | safeHtml"></div>
            </div>
            <div class="col-xxl-4 col-lg-4">
                <aside class="sidebar-area m-auto">
                    <div class="widget widget_info ">
                        <div class="job-sidebar">
                            <ul>
                                <li>
                                    <strong>Experience: </strong>
                                    <span>{{ data?.min_experience ?? '' }}</span>
                                </li>
                                <li>
                                    <strong>Working Hours: </strong>
                                    <span>9:00 AM to 6:00PM (45Min Break)</span>
                                </li>
                                <li>
                                    <strong>Working Days: </strong>
                                    <span>Weekly 6 days </span>
                                </li>
                                <li>
                                    <strong>Vacancy: </strong>
                                    <span>01</span>
                                </li>
                                <li>
                                    <strong>Deadline: </strong>
                                    <span>{{ data?.clossing_date }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="widget widget_info">
                        <div id="apply-job-section" class="apply-job-section w-100">
                            <h4>Submit Your Application</h4>
                            <form [formGroup]="applyForm" (ngSubmit)="onSubmit()" method="POST" id="apply-job-form" novalidate
                                enctype="multipart/form-data">
                                <!-- Name -->
                                <div class="form-group">
                                    <label>Name<span class="text-danger">*</span></label>
                                    <input type="text" formControlName="name" class="form-control" placeholder="Ex. John Doe"
                                        maxlength="64" />
                                    <div *ngIf="applyForm.get('name')?.touched && applyForm.get('name')?.invalid"
                                        class="text-danger">
                                        {{ getErrorMessage('name') }}
                                    </div>
                                </div>

                                <!-- Email -->
                                <div class="form-group">
                                    <label>Email<span class="text-danger">*</span></label>
                                    <input type="email" formControlName="email" class="form-control" placeholder="Ex. john@example.com"
                                        maxlength="64" />
                                    <div *ngIf="applyForm.get('email')?.touched && applyForm.get('email')?.errors?.['required']"
                                        class="text-danger">
                                        {{ getErrorMessage('email') }}
                                    </div>
                                </div>

                                <!-- Phone -->
                                <div class="form-group">
                                    <label>Phone<span class="text-danger">*</span></label>
                                    <input type="text" formControlName="phone" class="form-control" placeholder="XXXXXXXXXX"
                                        maxlength="12" (keypress)="onlyNumbers($event)" inputmode="numeric" />
                                    <div *ngIf="applyForm.get('phone')?.touched && applyForm.get('phone')?.invalid"
                                        class="text-danger">
                                        {{ getErrorMessage('phone') }}
                                    </div>
                                </div>

                                <!-- Max Qualification -->
                                <div class="form-group">
                                    <label>Max Qualification<span class="text-danger">*</span></label>
                                    <input type="text" formControlName="qualification" class="form-control" placeholder="Ex. MCA"
                                        maxlength="128" />
                                    <div *ngIf="applyForm.get('qualification')?.touched && applyForm.get('qualification')?.invalid"
                                        class="text-danger">
                                        {{ getErrorMessage('qualification') }}
                                    </div>
                                </div>

                                <!-- Current Company -->
                                <div class="form-group">
                                    <label>Current Company</label>
                                    <input type="text" formControlName="company" class="form-control" placeholder="Ex. Xipetech India"
                                        maxlength="128" />
                                </div>

                                <!-- Total Experience -->
                                <div class="form-group">
                                    <label>Total Experience<span class="text-danger">*</span></label>
                                    <input type="text" formControlName="experience" class="form-control" placeholder="Ex. 5 Years"
                                        maxlength="64" />
                                    <div *ngIf="applyForm.get('experience')?.touched && applyForm.get('experience')?.invalid"
                                        class="text-danger">
                                        {{ getErrorMessage('experience') }}
                                    </div>
                                </div>

                                <!-- Expected Salary -->
                                <div class="form-group">
                                    <label>Expected Salary<span class="text-danger">*</span></label>
                                    <input type="text" formControlName="salary" class="form-control" placeholder="Ex. Rs. 5,00,000"
                                        maxlength="64" />
                                    <div *ngIf="applyForm.get('salary')?.touched && applyForm.get('salary')?.invalid"
                                        class="text-danger">
                                        {{ getErrorMessage('salary') }}
                                    </div>
                                </div>

                                <!-- Resume Upload -->
                                <div class="form-group">
                                    <label>Resume (PDF/DOC)<span class="text-danger">*</span></label>
                                    <input type="file" (change)="onFileChange($event)" class="form-control pt-10px"
                                        [class.is-invalid]="hasError('resume')"
                                        accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" />
                                    <div *ngIf="hasError('resume')" class="text-danger">
                                        {{ getErrorMessage('resume') }}
                                    </div>
                                    <small class="text-muted">Max file size: 2MB. Allowed formats: PDF, DOC, DOCX</small>

                                    <!-- Show selected file name -->
                                    <div *ngIf="resumeFile" class="mt-2 text-success">
                                        <i class="fas fa-check-circle"></i> Selected: {{ resumeFile.name }}
                                    </div>
                                </div>

                                <!-- Submit Button -->
                                <button type="submit" class="th-btn mt-2" [disabled]="isLoading">
                                    <span *ngIf="!isLoading">Submit Application</span>
                                    <span *ngIf="isLoading" class="btn-loading">
                                        <span class="custom-spinner"></span> Submitting...
                                    </span>
                                </button>
                                <input type="hidden" formControlName="job_id" />
                            </form>
                        </div>
                    </div>
                </aside>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-12 mt-md-5">
                <div class="widget widget_banner" data-bg-src="assets/img/bg/widget_banner.jpg">
                        <div class="widget-banner position-relative text-center">
                            <span class="icon"><i class="fa-solid fa-phone"></i></span>
                            <span class="text">Need Help? Call Here</span>
                            <a class="phone" href="tel:+918090920216">+91-8090-920216</a>
                            <a routerLink="/contact" class="th-btn style6">Get A Quote <i
                                    class="fa-light fa-arrow-right-long"></i></a>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</section>
<!--======== Footer Section ========-->
<app-footer></app-footer>